export default "__VITE_ASSET__BCz_BGU___"